import { EllipsedText } from '@gorila-shared-ui/components';
import { ListItem, ListItemLabel } from 'baseui/list';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { formState, selectedFormIdState } from '../../storage/formStates';

type Props = {
  formId: string;
};
export function FormListItem({ formId }: Readonly<Props>) {
  const { theme } = useStyles();
  const [selectedForm, setSelectedForm] = useRecoilState(selectedFormIdState);
  const isSelected = selectedForm === formId;
  const form = useRecoilValue(formState(formId));

  if (!form) return null;

  const onSelectForm = () => {
    setSelectedForm(formId);
  };

  return (
    <ListItem
      overrides={{
        Root: {
          props: {
            onClick: onSelectForm,
          },
          style: {
            cursor: 'pointer',
            backgroundColor: isSelected ? theme.colors.backgroundTertiary : undefined,
            ':hover': {
              backgroundColor: theme.colors.backgroundSecondary,
            },
          },
        },
        Content: {
          style: {
            marginLeft: 0,
            paddingLeft: theme.sizing.scale600,
          },
        },
      }}
      sublist
    >
      <ListItemLabel>
        <EllipsedText inline>{form.name}</EllipsedText>
      </ListItemLabel>
    </ListItem>
  );
}
